<button
  id="primary-button"
  [class.disabled]="disabled() || loading()"
  [disabled]="disabled() || loading()"
  [type]="type()"
  [ngClass]="this.rounded()"
  class="relative box-border flex w-full flex-row items-center justify-center gap-x-2.5 border-2 border-primary-100 bg-primary-100 px-8 py-2 font-semibold text-neutral-0 no-underline hover:cursor-pointer hover:border-primary-130 hover:bg-primary-130 disabled:cursor-not-allowed disabled:border-neutral-60 disabled:bg-neutral-60">
  @if (loading()) {
    <div class="px-4 py-3">
      <span class="loading-spinner absolute left-1/2 top-1/2 -ml-3 -mt-3 h-6 w-6 min-w-6 border-2"></span>
    </div>
  } @else {
    <ng-content></ng-content>
  }
</button>
